import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { PessoaEstrangeiraVO } from '../shared/model';

@Injectable({
  providedIn: 'root'
})
export class PessoaEstrangeiraService {

  private readonly service = '/sepin-backend/rest/proxy/pessoa-estrangeira';

  constructor(private readonly http: McticHttpClient) {
  }

  consultarPorPassaporteIdPais(passaporte: string, idPais: number) {
    return this.http.get<PessoaEstrangeiraVO>(`${this.service}/atual/passaporte/${passaporte}/id-pais-passaporte/${idPais}`);
  }

  cadastrar(pessoa: PessoaEstrangeiraVO) {
    return this.http.post<PessoaEstrangeiraVO>(this.service, pessoa);
  }

  obterPorId(idUnico) {
    return this.http.get<PessoaEstrangeiraVO>(`${this.service}/${idUnico}`);
  }

}
